import DefaultLayout from "@/layouts/DefaultLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";

export const layouts = {
  DefaultLayout,
  AuthLayout,
};
